import Vue from 'vue'
import Vuex from 'vuex'

import Home from './modules/Home'
import BaseTask from "@/store/modules/BaseTask";
import SuperBomList from './modules/superBomList'
import SuperBom from './modules/superBom'
import SuperBomComponentList from './modules/superBomComponentList'
import SuperBomComponentAutoList from './modules/superBomComponentAutoList'
import SuperBomDetail from "@/store/modules/superBomDetail";
import ComponentDBAuthorization from "@/store/modules/componentDBAuthorization"
import MarginScheduling from "@/store/modules/marginScheduling";
import BrandList from "@/store/Brand/BrandList";
import BrandProviderList from "@/store/Brand/BrandProviderList";
import BrandProviderItem from "@/store/Brand/BrandProviderItem";
import BrandComponentProviderComponent from "@/store/Brand/BrandComponentProviderComponent";
import BrandComponentItem from "@/store/Brand/BrandComponentItem";
import BrandComponentList from "@/store/Brand/BrandComponentList";
import BrandComponentSpec from "@/store/Brand/BrandComponentSpec";

import AccountPermissionGroupList from "@/store/modules/AccountPermissionGroupList";
import AuthLogin from "@/store/modules/AuthLogin";

import MPNResearch from "@/store/MPNResearch/MPNResearch";
import MPNResearchBatch from "@/store/MPNResearch/MPNResearchBatch";
import MPNResearchDetail from "@/store/MPNResearch/MPNResearchDetail";

import MPNChecking from "@/store/MPNChecking/MPNChecking";
import Bom from "@/store/Bom/Bom";
import BomSheet from "@/store/Bom/BomSheet";

import StoreFile from "@/store/modules/StoreFile";
import StoreFileList from "@/store/modules/StoreFileList";
import StoreFileHistory from "@/store/modules/StoreFileHistory";
import StoreDocList from "@/store/modules/StoreDocList";
import StoreDocItem from "@/store/modules/StoreDocItem";

import Quote from "@/store/modules/Quote";

import Customer from "@/store/modules/Customer"


import BatchRun from "@/store/modules/BatchRun";
import BatchRunHistoryList from "@/store/modules/BatchRunHistoryList";
import BatchRunHistoryGraph from "@/store/modules/BatchRunHistoryGraph";
import BatchRunHistoryItem from "@/store/modules/BatchRunHistoryItem";
import BatchRunDialog from "@/store/modules/BatchRunDialog";
import BatchRunWeek from "@/store/modules/BatchRunWeek";

import CustomerOrderTable from "@/store/Product/CustomerOrder/CustomerOrderTable";
import ProductTable from "@/store/Product/Product/ProductTable";
import DeliveryTable from "@/store/BatchRun/Delivery/DeliveryTable";
import BatchRunTable from "@/store/BatchRun/BatchRun/BatchRunTable";
import TaskTypeTable from "@/store/Product/TaskType/TaskTypeTable";
import MachineTable from "@/store/Product/Machine/MachineTable";
import TaskTemplateTable from "@/store/Product/TaskTemplate/TaskTemplateTable";
import TaskTemplateOneTable from "@/store/Product/TaskTemplate/TaskTemplateOneTable";
import BatchRunMain from "@/store/BatchRun/BatchRun/BatchRunMain";


import CustomerOrder from "@/store/modules/CustomerOrder"

import Variant from "@/store/modules/Variant"
import User from "@/store/modules/User"

import BaseHistoryDetail from "@/store/modules/History/BaseHistoryDetail";
import BaseHistoryRestore from "@/store/modules/History/BaseHistoryRestore";

import BaseHistoryFileDetail from "@/store/modules/History/BaseHistoryFileDetail";
import BaseHistoryFileRestore from "@/store/modules/History/BaseHistoryFileRestore";

import TimeTracker from "@/store/TimeTracker/TimeTracker";
import TimeTrackerHoliday from "@/store/TimeTracker/TimeTrackerHoliday";
import HumanUser from "@/store/TimeTracker/HumanUser";
import CalendarEvent from "@/store/TimeTracker/CalendarEvent";
import Contract from "@/store/TimeTracker/Contract";
import CalendarDateUser from "@/store/TimeTracker/CalendarDateUser";
import CalendarDateUserDash from "@/store/TimeTracker/CalendarDateUserDash";
import CalendarDate from "@/store/TimeTracker/CalendarDate";
import CalendarDateUserWeek from "@/store/TimeTracker/CalendarDateUserWeek";
import CalendarDateUserStatisticRange from "@/store/TimeTracker/CalendarDateUserStatisticRange";
import CalendarDateUserStatisticBegin from "@/store/TimeTracker/CalendarDateUserStatisticBegin";
import HRDepartment from "@/store/TimeTracker/HRDepartment";
import HRPayed from "@/store/TimeTracker/HRPayed";
import CalendarVacationTable from "@/store/HR/CalendarVacationTable";

import CustomerTable from "@/store/Product/Customer/CustomerTable";

import LibraryFileTable from "@/store/LibraryDoc/LibraryFileTable";
import LibraryDocTable from "@/store/LibraryDoc/LibraryDocTable";
import LibraryTopicTable from "@/store/LibraryDoc/LibraryTopicTable";

import HistoryTable from "@/store/History/HistoryTable";

import UserTable from "@/store/User/UserTable";
import GroupTable from "@/store/User/GroupTable";

import BomTable from "@/store/Component/BomTable";
import BomSheetTable from "@/store/Component/BomSheetTable";
import ComponentTable from "@/store/Component/ComponentTable";
import ComponentShortTable from "@/store/Component/ComponentShortTable";
import ComponentPackagingTable from "@/store/Component/ComponentPackagingTable";
import ComponentOneTable from "@/store/Component/ComponentOneTable";
import ComponentArticleSelectTable from "@/store/Component/ComponentArticleSelectTable";
import ComponentAliasSelectTable from "@/store/Component/ComponentAliasSelectTable";
import TypeCategoryPackageTable from "@/store/Component/TypeCategoryPackageTable";
import ProviderTable from "@/store/Component/ProviderTable";
import CategoryTable from "@/store/Component/CategoryTable";
import SubcategoryTable from "@/store/Component/SubcategoryTable";
import CasePackageTable from "@/store/Component/CasePackageTable";
import CasePackageSelectTable from "@/store/Component/CasePackageSelectTable";
import PickPlaceTable from "@/store/Component/PickPlaceTable";
import PickPlaceSheetTable from "@/store/Component/PickPlaceSheetTable";
import ProviderCustomerTable from "@/store/Component/ProviderCustomerTable";

import WorkerTable from "@/store/Broker/WorkerTable";
import OctopartAccountTable from "@/store/Component/OctopartAccountTable";

import SpecAttrTable from "@/store/Component/SpecAttrTable";
import SpecAttrComponentTable from "@/store/Component/SpecAttrComponentTable";
import SpecAttrCategory from "@/store/Component/SpecAttrCategory";

import TaskTable from "@/store/Task/TaskTable";

import PBatchRunTable from "@/store/PBatchRun/PBatchRunTable";
import PCustomerOrderSelectTable from "@/store/PBatchRun/PCustomerOrderSelectTable";
import PCustomerOrderSoloTable from "@/store/PBatchRun/PCustomerOrderSoloTable";
import PVariantSoloTable from "@/store/PBatchRun/PVariantSoloTable";
import PBatchRunTaskTable from "@/store/PBatchRun/PBatchRunTaskTable";
import PVariantTaskTable from "@/store/PBatchRun/PVariantTaskTable";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Home,
        BaseTask,

        SuperBom,
        SuperBomList,
        SuperBomComponentList,
        SuperBomComponentAutoList,
        SuperBomDetail,
        ComponentDBAuthorization,

        MarginScheduling,
        BatchRun,
        BatchRunHistoryList,
        BatchRunHistoryGraph,
        BatchRunHistoryItem,
        BatchRunDialog,
        BatchRunWeek,

        CustomerOrderTable,
        ProductTable,
        DeliveryTable,
        BatchRunTable,
        TaskTypeTable,
        MachineTable,
        TaskTemplateTable,
        TaskTemplateOneTable,
        BatchRunMain,

        BrandList, BrandProviderList, BrandProviderItem, BrandComponentItem, BrandComponentProviderComponent,
        BrandComponentList, BrandComponentSpec,

        AccountPermissionGroupList, AuthLogin,

        MPNResearch, MPNResearchBatch, MPNResearchDetail, MPNChecking,

        Bom, BomSheet,

        StoreFile,
        // StoreFileList,
        StoreFileHistory,
        StoreDocList,
        StoreDocItem,

        Quote,
        Customer,
        CustomerOrder,
        Variant,
        User,

        BaseHistoryDetail,
        BaseHistoryRestore,

        BaseHistoryFileDetail,
        BaseHistoryFileRestore,
        TimeTracker,
        TimeTrackerHoliday,
        HumanUser,
        CalendarEvent,
        Contract,
        CalendarDateUser,
        CalendarDateUserDash,
        CalendarDate,
        CalendarDateUserWeek,
        CalendarDateUserStatisticRange,
        CalendarDateUserStatisticBegin,
        HRDepartment,
        HRPayed,
        CalendarVacationTable,

        CustomerTable,

        LibraryFileTable,
        LibraryDocTable,
        LibraryTopicTable,

        HistoryTable,

        UserTable,
        GroupTable,

        BomTable,
        BomSheetTable,
        ComponentTable,
        ComponentOneTable,
        ComponentShortTable,
        ComponentPackagingTable,
        ComponentArticleSelectTable,
        ComponentAliasSelectTable,
        TypeCategoryPackageTable,
        ProviderTable,
        CategoryTable,
        SubcategoryTable,
        CasePackageTable,
        CasePackageSelectTable,
        PickPlaceTable,
        PickPlaceSheetTable,
        ProviderCustomerTable,

        WorkerTable,
        OctopartAccountTable,

        SpecAttrTable,
        SpecAttrComponentTable,
        SpecAttrCategory,

        TaskTable,

        PBatchRunTable,
        PCustomerOrderSelectTable,
        PCustomerOrderSoloTable,
        PVariantSoloTable,
        PBatchRunTaskTable,
        PVariantTaskTable,
    },
})

